import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from '../../utils/API/requestMiddleware';

const productsAPI = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'productsAPI',
    endpoints: (builder) => ({

        getProductList: builder.query({
            query: function (params) {
                const { url } = params;

                let { first, rows, sortField, sortOrder, search, ...retVal } = params.params;

                retVal.Pagination = {
                    PageNumber: (first / rows) + 1,
                    PageSize: rows
                };
                retVal.filters = { searchText: search || "" };
                retVal.sortString = '';
                //retVal.pageIndex = (first / rows);
                //retVal.pageSize = rows;

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }
                return {
                    url: params.url,
                    params: { requestData: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getErrorProductList: builder.query({
            query: function (params) {
                const { url } = params;

                let { first, rows, sortField, sortOrder, search, ...retVal } = params.params;

                retVal.Pagination = {
                    PageNumber: (first / rows) + 1,
                    PageSize: rows
                };
                retVal.filters = { searchText: search || "" };
                retVal.sortString = '';
                //retVal.pageIndex = (first / rows);
                //retVal.pageSize = rows;

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }
                return {
                    url: params.url,
                    params: { requestData: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateProductPropertyValue: builder.mutation({
            query: (details) => ({
                url: '/Product/UpdateProductPropertyValue',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProductDetailByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetProductDetailByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        GetProductTabCountsByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetProductTabCountsByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getRenderImagebychemProductIdAndInchikey: builder.query({
            query: (request) => ({
                url: `/Regulation/GetRenderImagebychemProductIdAndInchikey?chemProductID=${request.chemProductID}&inChIKey=${request.inChIKey}`,
                method: 'GET',
                responseHandler: (response) => response.blob()
            }),
            // transformResponse: transformSucessResponse,
            transformResponse: async (blob) => {
                const url = URL.createObjectURL(blob);
                return url;
            },
            transformErrorResponse: transformErrorResponse
        }),

        getProductSafetyAndHazardByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetProductSafetyAndHazardByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProductSynonymByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetProductSynonymByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProductTautomerSmilesByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetProductTautomerSmilesByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        
        getProductIsomerSmilesByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetProductIsomerSmilesByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getPatternsByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetPatternsByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProductPropertiesByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetProductPropertiesByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAssociatedChemProductByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetAssociatedChemProductByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getChemProductSaltsDetailsByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Product/GetChemProductSaltsDetailsByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProductSynonymByChemProductIdAndSynonymTypeId: builder.query({
            query: ({ chemProductId, synonymTypeId }) => ({
                url: encryptQueryString(`/Product/GetProductSynonymByChemProductIdAndSynonymTypeId?chemProductId=${chemProductId}&synonymTypeId=${synonymTypeId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateProductSynonymById: builder.mutation({
            query: (details) => ({
                url: '/Product/UpdateProductSynonymById',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // deleteProductSynonymById: builder.mutation({
        //     query: (synonymId) => ({
        //         url: `/Product/DeleteProductSynonymById?synonymId=${synonymId}`,
        //         method: 'DELETE',
        //     }),
        //     transformResponse: transformSucessResponse,
        //     transformErrorResponse: transformErrorResponse,
        // }),

        deleteProductSynonymById: builder.mutation({
            query: ({ synonymId, deletedBy }) => ({
                url: `/Product/DeleteProductSynonymById?synonymId=${synonymId}&deletedBy=${deletedBy}`,
                method: 'DELETE',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


        updateSafetyHazardValue: builder.mutation({
            query: (details) => ({
                url: '/Product/UpdateSafetyHazardValueById',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteSafetyHazardValueById: builder.mutation({
            query: ({ safetyValueID, deletedBy }) => ({
                url: `/Product/DeleteSafetyHazardValueById?SafetyValueID=${safetyValueID}&deletedBy=${deletedBy}`,
                method: 'DELETE',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


        UpdateTutomerStatusById: builder.mutation({
            query: (details) => ({
                url: '/Product/UpdateTutomerStatusById',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getTutomerStatusList: builder.query({
            query: () => ({
                url: '/Product/GetTutomerStatusList',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteProductPropertyValueId: builder.mutation({
            query: ({ propertyValueId, deletedBy }) => ({
                url: `/Product/DeleteProductPropertyValueId?propertyValueId=${propertyValueId}&deletedBy=${deletedBy}`,
                method: 'DELETE'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addProductPropertyValue: builder.mutation({
            query: (details) => ({
                url: '/Product/AddProductPropertyValue',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addProductSafetyHazardValue: builder.mutation({
            query: (details) => ({
                url: '/Product/AddProductSafetyHazardValue',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addSynonymValue: builder.mutation({
            query: (details) => ({
                url: '/Product/AddProductSynonym',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
});

export const { useLazyGetProductListQuery, useUpdateProductPropertyValueMutation, useLazyGetErrorProductListQuery,
    useLazyGetProductDetailByChemProductIdQuery, useGetProductTabCountsByChemProductIdQuery, useLazyGetRenderImagebychemProductIdAndInchikeyQuery,
    useLazyGetProductSafetyAndHazardByChemProductIdQuery, useLazyGetProductSynonymByChemProductIdQuery,
    useLazyGetProductTautomerSmilesByChemProductIdQuery, useLazyGetProductIsomerSmilesByChemProductIdQuery, 
    useLazyGetPatternsByChemProductIdQuery,
    useLazyGetProductPropertiesByChemProductIdQuery,
    useLazyGetAssociatedChemProductByChemProductIdQuery, useLazyGetChemProductSaltsDetailsByChemProductIdQuery,
    useLazyGetProductSynonymByChemProductIdAndSynonymTypeIdQuery, useUpdateProductSynonymByIdMutation,
    useDeleteProductSynonymByIdMutation, useUpdateSafetyHazardValueMutation, useDeleteSafetyHazardValueByIdMutation,
    useUpdateTutomerStatusByIdMutation, useDeleteProductPropertyValueIdMutation, useLazyGetTutomerStatusListQuery,
    useAddProductPropertyValueMutation, useAddProductSafetyHazardValueMutation, useAddSynonymValueMutation } = productsAPI;

export default productsAPI;